var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"btn-icon",attrs:{"variant":"flat-secondary","to":{ name: 'me-coupon'}}},[_c('feather-icon',{staticClass:"text-body",attrs:{"icon":"GiftIcon","size":"21"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }